import React, {useEffect, useState} from 'react'
import EventEmitter from 'eventemitter3'
import UIGameAchievement from './UIGameAchievement'
import {PlayerColor} from '@colonist/game-states'
import {GameAchievementType} from './type'
import {useGameStore} from '../../store/GameStoreContext'
import {useIsReplay} from '../../store/selectors/useIsReplay'

export interface UIGameAddAchievementEvent {
    achievementOwnerNew: PlayerColor
    achievementOwnerPrevious?: PlayerColor | undefined
    achievementType: GameAchievementType
    achievementScore?: number
}

export interface UIGameAchievementEvents {
    addAchievement: UIGameAddAchievementEvent
}

export const UIGameAchievementEventEmitter = new EventEmitter<UIGameAchievementEvents>()

export const UIGameAchievementContainer = () => {
    const [achievements, setAchievements] = useState<UIGameAddAchievementEvent[]>([])
    const isReplay = useIsReplay()

    useEffect(() => {
        const addAchievement = (achievement: UIGameAddAchievementEvent) => {
            if(isReplay === true) return

            setAchievements((prev) => [...prev, achievement])
        }

        UIGameAchievementEventEmitter.on('addAchievement', addAchievement)

        return () => {
            UIGameAchievementEventEmitter.off('addAchievement', addAchievement)
        }
    }, [isReplay])

    const handleDisappear = () => {
        setAchievements((prev) => prev.slice(1))
    }

    const firstAchievement = achievements[0]
    if(firstAchievement == undefined) return null

    const key = `${firstAchievement.achievementOwnerNew}-${firstAchievement.achievementType}-${firstAchievement.achievementScore}`

    return (
        <UIGameAchievementWrapper key={key} {...firstAchievement} onDisappear={handleDisappear} />
    )
}

interface UIGameAchievementWrapperProps extends UIGameAddAchievementEvent {
    onDisappear: () => void
}

const UIGameAchievementWrapper = ({
    achievementOwnerNew,
    achievementOwnerPrevious,
    achievementType,
    achievementScore,
    onDisappear,
}: UIGameAchievementWrapperProps) => {
    const myColor = useGameStore((state) => state.myColor)
    const isConfettiEnabled = achievementOwnerNew === myColor

    const getUserState = useGameStore((state) => state.gameUserStates.getUserState)
    const achievementOwnerNewUserState = getUserState(achievementOwnerNew)
    const isPreviousOwnerDefined = achievementOwnerPrevious != undefined && achievementOwnerPrevious !== PlayerColor.None
    const achievementOwnerPreviousUserState = isPreviousOwnerDefined ? getUserState(achievementOwnerPrevious) : undefined

    const translationKeyContext = useGameStore((state) => state.gameMode.translationKeyContext)

    return <UIGameAchievement
        isConfettiEnabled={isConfettiEnabled}
        achievementOwnerNew={achievementOwnerNewUserState}
        achievementOwnerPrevious={achievementOwnerPreviousUserState}
        achievementType={achievementType}
        achievementScore={achievementScore}
        translationContext={translationKeyContext}
        onDisappear={onDisappear} />
}
